import { UseQueryOptions } from '@tanstack/react-query';
import bookingSummaryApi from '@/features/public/bookingSummary/api/bookingSummaryApi.ts';
import { bookingSummaryApiQueryKeys } from '@/features/public/bookingSummary/api/bookingSummaryApi.queryKeys.ts';
import { BookingPublicSummaryDto } from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';

export const getBookingSummaryQueryOptions = (
  orgSlug: string,
  token: string,
): UseQueryOptions<BookingPublicSummaryDto> => ({
  queryKey: bookingSummaryApiQueryKeys.summary(orgSlug, token),
  queryFn: () => bookingSummaryApi.getBookingSummary(orgSlug, token),
  enabled: !!orgSlug && !!token,
});
